// extracted by mini-css-extract-plugin
module.exports = {"container":"tabCloseConfirmDialog__container___11H91","content":"tabCloseConfirmDialog__content___2QJO2","description":"tabCloseConfirmDialog__description___SBawK"};